export const GET_TABLE_DATA_REQUEST = 'GET_TABLE_DATA_REQUEST';
export const GET_TABLE_DATA_SUCCESS = 'GET_TABLE_DATA_SUCCESS';
export const GET_TABLE_DATA_FAILED = 'GET_TABLE_DATA_FAILED';

export const GET_TABLE_DATA_BY_URL_REQUEST = 'GET_TABLE_DATA_BY_URL_REQUEST';
export const GET_TABLE_DATA_BY_URL_SUCCESS = 'GET_TABLE_DATA_BY_URL_SUCCESS';
export const GET_TABLE_DATA_BY_URL_FAILED = 'GET_TABLE_DATA_BY_URL_FAILED';

export const GET_TABLE_DATA_FILTER_CHOICES_REQUEST = 'GET_TABLE_DATA_FILTER_CHOICES_REQUEST';
export const GET_TABLE_DATA_FILTER_CHOICES_SUCCESS = 'GET_TABLE_DATA_FILTER_CHOICES_SUCCESS';
export const GET_TABLE_DATA_FILTER_CHOICES_FAILED = 'GET_TABLE_DATA_FILTER_CHOICES_FAILED';

export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_REQUEST =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_REQUEST';
export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_SUCCESS =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_SUCCESS';
export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_FAILED =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_FAILED';

export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_REQUEST =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_REQUEST';
export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_SUCCESS =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_SUCCESS';
export const GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_FAILED =
  'GET_TABLE_DATA_ANGUCOMPLETE_SEARCH_BY_URL_FAILED';

export const SET_TABLE_DATA_INFO = 'SET_TABLE_DATA_INFO';
export const SET_TABLE_DETAIL_URL = 'SET_TABLE_DETAIL_URL';
